import gsap from 'gsap'
import Swiper from 'swiper'

class App {

  constructor($) {
    this.create()
  }

  create() {

    $('body').addClass('loaded')

    setTimeout(function(){ $('body').addClass('initialised') }, 1000);


    this.flkty = new Swiper('.swiper', {
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      speed: 750,
      slidesPerView: 1,
       loop: true
    });

    const locations = ['soho', 'canary']
    this.counter = $('.counter-current')

    this.flkty.on('realIndexChange', (swiper) => {


      const index = swiper.realIndex
      //console.log(index, 'change');
      this.counter.html(index + 1)
      this.removeClassByPrefix(document.body, 'is-')
      document.body.classList.add(`is-${locations[index]}`)
      document.body.classList.add(`will-${locations[index]}`)

      //1 change - fade out soho - .fadeout-soho
      //0 change - fade out canary 
      
    });
 



    $('.menu-button').on('click', (e)=>{

      e.preventDefault()

       if ($('body').hasClass("has-menu")) {
        // this.flkty.unpausePlayer()
       }

      if(!$('body').hasClass("has-menu")){
        $('.menu-page').scrollTop(0)
       // this.flkty.pausePlayer()
      }

      $('body').removeClass('has-reservations')
      $('body').toggleClass('has-menu')
    })


     $('.show-menu--canary').on('click', (e) => {

       e.preventDefault()
       $('.show-menu--canary').addClass('show-menu--is-selected')
       $('.show-menu--soho').removeClass('show-menu--is-selected')
       $('body').addClass('has-menu-canary')
     })

     $('.show-menu--soho').on('click', (e) => {

       e.preventDefault()
       $('.show-menu--soho').addClass('show-menu--is-selected')
       $('.show-menu--canary').removeClass('show-menu--is-selected')
       $('body').removeClass('has-menu-canary')
     })

     $('.reservations__switch--faq').on('click', (e) => {

       e.preventDefault()
       $('body').addClass('has-faq')
     })
      $('.reservations__switch--reservations').on('click', (e) => {

        e.preventDefault()
        $('body').removeClass('has-faq')
      })


     


$('.faq-button').on('click', (e) => {

  e.preventDefault()

  if ($('body').hasClass("has-mfaq")) {
    //this.flkty.playPlayer()
  }

  if (!$('body').hasClass("has-mfaq")) {
    $('.menu-page').scrollTop(0)

   // this.flkty.stopPlayer()

  }
  $('body').removeClass('has-menu')
  $('body').removeClass('has-reservations')
  $('body').addClass('has-mfaq')
})

$('.mobile-faq').on('click', (e) => {

  e.preventDefault()

  if (!$('body').hasClass("has-menu")) {
    $('.menu-page').scrollTop(0)
  }
  $('body').removeClass('has-menu')
  $('body').removeClass('has-reservations')
  $('body').removeClass('has-mfaq')
})



    $('.reservations-but').on('click', (e)=>{

      e.preventDefault()

     if($('body').hasClass("has-reservations")){
      //  this.flkty.playPlayer()
     }

      if(!$('body').hasClass("has-reservations")){
        $('.menu-page').scrollTop(0)
       
        //  this.flkty.stopPlayer()

      }
      $('body').removeClass('has-menu')
      $('body').toggleClass('has-reservations')
    })


    $('.mobile-button').on('click', (e)=>{

      e.preventDefault()

      if(!$('body').hasClass("has-menu")){
        $('.menu-page').scrollTop(0)
      }
      $('body').removeClass('has-reservations')
      $('body').toggleClass('has-menu')
    })

    $('.mobile-reservations').on('click', (e)=>{

      e.preventDefault()

      if(!$('body').hasClass("has-menu")){
        $('.menu-page').scrollTop(0)
      }
      $('body').removeClass('has-menu')
      $('body').toggleClass('has-reservations')
    })


    this.modal = document.getElementById('modal')
    this.iframe = document.getElementById('modal__iframe')

     $('[data-button]').on('click', (e) => {
       this.close()
     })

     this.locations = document.querySelectorAll('.reservations__button')
     this.locations.forEach((item) => {


           $(item).on('click', (e) => {
             e.preventDefault()
             const loc = `https://www.sevenrooms.com/reservations/${item.dataset.location}?duration-picker=true`
             const img = item.dataset.location
             this.show(loc, img)
             //window.fbq && fbq('track', 'InitiateCheckout');

           })

          })
        
      


  }

  show(loc) {

   
    this.iframe.src = loc
    this.modal.classList.add('is-opened')


  }

  close() {

    this.modal.classList.remove('is-opened', 'has-overlay')
    this.iframe.src = ""

  }

  showError(error){

      $('.errors-text').html(error)
  }

  removeClassByPrefix(node, prefix) {
    var regx = new RegExp('\\b' + prefix + '[^ ]*[ ]?\\b', 'g');
    node.className = node.className.replace(regx, '');
    return node;
  }


  mailchimp(email, url) {

    var data = {
      'EMAIL': email,
      utf8: '✓'
    };

    var promise = $.ajax({
        url: url ,
        method: 'post',
        data: data,
        cache       : false,
        dataType    : 'jsonp',
        jsonp: 'c',
        contentType: "application/json; charset=utf-8"
    })

    return promise;
  }


}

module.exports = App
